import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useCallback, useEffect, useRef, useState } from 'react';
import { TribeClient } from '@tribeplatform/gql-client';
import { getTokens } from './lib/getTokens';
import { defaultTracker, TribeTracker } from './TrackerProvider';
export const ClientContext = createContext({
    client: null,
    ready: undefined,
    boot: null,
    config: null,
});
const SSR = typeof window === 'undefined';
export const ClientProvider = ({ children, config, autoBoot = true, onTokenUpdate, }) => {
    var _a, _b, _c;
    const { accessToken, baseUrl, gatewayCacheControl } = config;
    const loadingRef = useRef(false);
    let graphqlUrl = baseUrl;
    if (!graphqlUrl && typeof process !== 'undefined') {
        graphqlUrl = (_a = process === null || process === void 0 ? void 0 : process.env) === null || _a === void 0 ? void 0 : _a.TRIBE_GQL_ENDPOINT;
    }
    const [client, setClient] = useState(new TribeClient({
        accessToken,
        graphqlUrl,
        onError: config.onError,
        onEvent: config.onEvent,
        notifyOnTokenExpiration: !SSR,
        gatewayCacheControl,
    }));
    const ready = !!((_c = (_b = client) === null || _b === void 0 ? void 0 : _b.client) === null || _c === void 0 ? void 0 : _c.accessToken);
    const update = useCallback(async (config) => {
        const res = await getTokens(config);
        const { client: newClient } = res;
        setClient(newClient);
        loadingRef.current = false;
        return res;
    }, [setClient, loadingRef]);
    useEffect(() => {
        if (autoBoot && !loadingRef.current && !ready) {
            loadingRef.current = true;
            update(config);
        }
    }, [loadingRef, update, client, ready, config, autoBoot]);
    const boot = () => {
        update(config);
    };
    return (_jsx(ClientContext.Provider, { value: { client, ready, boot, config, onTokenUpdate }, children: _jsx(TribeTracker, { value: config.tracker || defaultTracker, children: children }, void 0) }, void 0));
};
//# sourceMappingURL=ClientProvider.js.map